export const tourSteps = [
  {
    selector: '.grids-card',
    content:
      'Hai să vedem împreună cum funcționează platforma! Navighează către pagina de grile! <br /><br /> Poți închide tutorialul din X-ul de mai sus',
    showNext: false,
    showPrev: false,
    url: '/acasa',
  },
  {
    content: '',
    pause: true,
  },
  {
    selector: '.grid-info',
    content: 'Aici găsești detaliile grilei',
    showNext: true,
    showPrev: false,
    url: '/rezolva-grile',
  },
  // {
  //   selector: '.info-modal',
  //   content:
  //     'Aici poți vedea la ce pagini găsești informațiile necesare pentru această grilă. Dacă dai click pe numărul paginii, vei fi redirecționat către pagina respectivă din carte.',
  //   pagesOnly: true,
  //   showNext: true,
  //   showPrev: true,
  //   url: '/rezolva-grile',
  // },
  {
    selector: '.hint-modal',
    content: 'De aici poți cere un indiciu.',
    showNext: true,
    showPrev: true,
    url: '/rezolva-grile',
  },
  {
    selector: '.content-container',
    content: 'E timpul să alegi un răspuns.',
    showNext: false,
    showPrev: true,
    url: '/rezolva-grile',
  },
  {
    selector: '.submit-grid',
    content: 'Verifică-ți răspunsul.',
    showNext: false,
    showPrev: false,
    url: '/rezolva-grile',
  },
  {
    selector: '.explanation',
    content: 'Vezi explicația grilei.',
    showNext: true,
    showPrev: false,
    url: '/rezolva-grile',
  },
  {
    selector: '.hint-icon',
    content: 'Salvează grila pentru a o putea găsi mai ușor în viitor.',
    showNext: true,
    showPrev: true,
    url: '/rezolva-grile',
  },
  // {
  //   selector: '.next-grid',
  //   content: 'Treci la următoarea grilă.',
  //   showNext: false,
  //   showPrev: true,
  //   url: '/rezolva-grile',
  // },
  {
    selector: '.sidenav-toggle',
    content: 'Deschide meniul.',
    mobileOnly: true,
    showNext: false,
    showPrev: false,
    url: '/rezolva-grile',
  },
  {
    selector: '#dashboard-nav-button',
    content: 'Mergi către pagina de statistici',
    showNext: false,
    showPrev: false,
    url: '/rezolva-grile',
  },
  {
    selector: '.dashboard-container',
    content:
      'Aici, poți să îți urmărești progresul și să vezi unde trebuie sa mai lucrezi.',
    showNext: true,
    showPrev: false,
    url: '/statistici',
  },
  {
    selector: '.sidenav-toggle',
    content: 'Deschide meniul.',
    mobileOnly: true,
    showNext: false,
    showPrev: true,
    url: '/statistici',
  },
  {
    selector: '#subject-nav-button',
    content: 'Mergi către pagina de simulări.',
    showNext: false,
    showPrev: true,
    url: '/statistici',
  },
  {
    selector: '.pick-subject-container',
    content:
      'Aici poți rezolva una din admiterile date în anii trecuți sau una complet noua, generată de noi. <br /><br /> Și cu asta, ai terminat turul platformei! Contactează-ne oricând pentru orice fel de întrebări!',
    showNext: false,
    showPrev: false,
    url: '/simulari',
  },
]
